import { type RootState } from "@ds/store/bootstrap";

const selectBaseState = (state: RootState) => state.settings.common;

export const selectCurrentView = (state: RootState) => selectBaseState(state).viewType;
